<template>
  <div
    ref="copyToClipboardWrapper"
    class="ce-copyToClipboard">
    <div @click.prevent="">
      <slot />
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard';
import { logger } from 'utils';

export default {
  props: {
    content: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      clipboard: null
    };
  },
  mounted() {
    const vm = this;
    this.clipboard = new ClipboardJS(
      this.$refs.copyToClipboardWrapper,
      {
        text: vm.copyHandler
      }
    );

    this.clipboard.on('success', this.successHandler);
    this.clipboard.on('error', this.errorHandler);
  },
  methods: {
    copyHandler() {
      return this.content;
    },
    successHandler() {
      this.$notification.success(this.$t('generic.copyToClipboard.success'));
    },
    errorHandler(e) {
      this.$notification.error(this.$t('generic.copyToClipboard.error'));
      logger.captureException(e);
    }
  }
};
</script>
